import React from 'react';
import { useNavigate } from 'react-router-dom';
import csvParse from 'csv-parse/lib/browser/sync';
import { Modal } from '../../common/Modal';
import { View } from '../../common/View';
import { Paragraph } from '../../common/Paragraph';
import { ButtonWithLoading } from '../../common/Button';

type OnboardingMintModalProps = {
  onClose: () => void;
};

export function OnboardingMintModal({ onClose }: OnboardingMintModalProps) {
  const navigate = useNavigate();

  return (
    <Modal
      isCurrent={true}
      stackIndex={0}
      showClose={false}
      title="Import Your Mint Transaction Data"
      onClose={() => onClose()}
    >
      {() => (
        <View style={{ maxWidth: 500 }}>
          <Paragraph>
            <ol>
              <li>
                How do I download my Mint transactions? <a target="_blank" href="https://mint.intuit.com/support/en-us/help-article/bank-transactions/download-transactions/L4VNv2fMR_US_en_US">Click Here</a> for Mint’s instructions, as well as a video to help you download your Mint data. We strongly recommend downloading your data to a desktop, rather than a mobile device!
              </li>
              <li>
                Once you’ve downloaded your file, click on <b>Upload file</b> and select your downloaded transactions file. We’ll walk you through the rest!
              </li>
            </ol>
          </Paragraph>
          <View style={{ alignItems: 'center' }}>
            <ButtonWithLoading type="primary" onClick={onImport}>
              Select file...
            </ButtonWithLoading>
          </View>
        </View>
      )}
    </Modal>
  );

  async function onImport() {
    await window.Actual.openFileDialog(
      {
        properties: ['openFile'],
        filters: [{ name: 'mint', extensions: ['csv'] }],
      },
      buffer => {
        const json = csvParse(new Uint8Array(buffer), {
          bom: true,
          quote: '"',
          trim: true,
          relax_column_count: true,
          skip_empty_lines: true,
          columns: header => {
            return header.map(column => column.replace(/\s+/g, ''));
          },
        });

        navigate('/onboarding/mint-mapping', {
          state: json,
        });
      },
    );
  }
}
